import { Lang, TurboTemplate } from '../../typings/common';

export const getTurboTemplateNameById = (templateId: TurboTemplate, lang: Lang): string | undefined => {
    let resultLang;

    if ([Lang.ru, Lang.uk].includes(lang)) {
        resultLang = 'ru';
    } else {
        resultLang = 'en';
    }

    return `${templateId}/${resultLang}`;
};
